import {
  HEADER_DOCTOR_LABEL_CLICK,
  HEADER_LABELS,
  HEADER_NEWSLETTER_LABEL_CLICK,
  HEADER_NOW_LABEL_CLICK,
  HEADER_SEARCH_BUTTON_CLICK,
  HEADER_VOUCHER_LABEL_CLICK,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import { getExperimentNamePerTenant } from 'shared/experiments/utils/tenantBasedExperimentsUtils'
import trackOptimizelyEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import store from 'shared/store'
import { isMobile } from 'shared/utils/deviceClassUtils'

export default () => {
  const { tenant, deviceClass } =
    store.getState()?.publicRuntimeConfig?.publicConfig || {}

  const headerLabelsExperiment = getExperimentNamePerTenant(
    HEADER_LABELS,
    tenant,
    deviceClass
  )
  const { isEnabled } = getExperimentOnClient(headerLabelsExperiment)

  if (!isEnabled || isMobile(deviceClass)) {
    return
  }

  void activateExperiment(headerLabelsExperiment)

  document.addEventListener('click', event => {
    const element = <HTMLElement>event.target

    if (element.closest('[data-qa-id="search-box-query-button"]')) {
      trackOptimizelyEvent(HEADER_SEARCH_BUTTON_CLICK)
    } else if (element.closest('[data-qa-id="form-menu-button-newsletter"]')) {
      trackOptimizelyEvent(HEADER_NEWSLETTER_LABEL_CLICK)
    } else if (element.closest('[data-qa-id="form-menu-button-ods"]')) {
      trackOptimizelyEvent(HEADER_DOCTOR_LABEL_CLICK)
    } else if (element.closest('[data-qa-id="form-menu-button-vouchers"]')) {
      trackOptimizelyEvent(HEADER_VOUCHER_LABEL_CLICK)
    } else if (
      element.closest('[data-qa-id="form-menu-button-now-delivery"]')
    ) {
      trackOptimizelyEvent(HEADER_NOW_LABEL_CLICK)
    }
  })
}
